/* eslint-disable no-undef */
/* eslint-disable no-case-declarations */
import CONSTANTS from "../../assets/js/Constants"

const system = {
   scrollTop: false,
   isLoading: false,
   window: {},
   confirm: {
      show: false,
      payload: {
         title: ""
      }
   },
   isShowDashBoard: true,
   isShowFDashBoard: true,
   language: { key: "vi" },
   authenticated: false,
   reportFeeTransportation: { list_data_report: [] }
}

export default function (state = system, { type, payload }) {
   switch (type) {
      case CONSTANTS.ACTION.SYSTEM.SET_LANGUAGE:
         const lang = { key: payload.key, code: payload.code, value: payload.value }
         // Cập nhật xuống localCookie
         CONSTANTS.FUNCTION.COMMON.cookieStorage.set("lang", CONSTANTS.FUNCTION.PRIVATE.encodedByClientKey(lang))
         return { ...state, language: { ...lang } }

      case CONSTANTS.ACTION.SYSTEM.ON_RESIZE:
         return { ...state, window: { ...state.window, ...payload } }

      case CONSTANTS.ACTION.SYSTEM.SET_HEIGHT_DASHBOARD:
         return { ...state, window: { ...state.window, heightDashboard: payload } }

      case CONSTANTS.ACTION.SYSTEM.IS_SHOW_FDASHBOARD:
         return { ...state, isShowFDashBoard: payload }

      case CONSTANTS.ACTION.SYSTEM.REPORT_FEE_TRANSPORTATION:
         return { ...state, reportFeeTransportation: { list_data_report: [] } }

      case CONSTANTS.ACTION.SYSTEM.UPDATE_REPORT_FEE_TRANSPORTATION:
         return { ...state, reportFeeTransportation: payload }

      case CONSTANTS.ACTION.SYSTEM.IS_SHOW_LOADING:
         return { ...state, isLoading: true }

      case CONSTANTS.ACTION.SYSTEM.IS_HIDE_LOADING:
         return { ...state, isLoading: false }

      case CONSTANTS.ACTION.SYSTEM.AUTHORIZATION:
         return { ...state, authenticated: payload }

      case CONSTANTS.ACTION.SYSTEM.STATUS:
         if (payload) toast(translate.t("common.update_successful"))
         else toast(translate.t("common.update_unsuccessful"), "error")
         return { ...state }
      case CONSTANTS.ACTION.SYSTEM.SHOW_MESSAGE:
         toast(translate.t(payload))
         return { ...state }

      case CONSTANTS.ACTION.SYSTEM.SHOW_CONFIRM_MODAL:
         return { ...state, confirm: { ...payload, show: true } }

      case CONSTANTS.ACTION.SYSTEM.HIDE_CONFIRM_MODAL:
         return { ...state, confirm: { ...state.confirm, show: false } }

      case CONSTANTS.ACTION.TYPE_TRANSPORTATION.GET_TYPE_TRANSPORTATION:
         return { ...state, typeTransportation: [] }

      case CONSTANTS.ACTION.TYPE_TRANSPORTATION.SET_TYPE_TRANSPORTATION:
         return { ...state, typeTransportation: [...payload] }

      case CONSTANTS.ACTION.FORM_TRANSPORTATION.GET_FORM_TRANSPORTATION:
         return { ...state, formTransportation: [] }

      case CONSTANTS.ACTION.FORM_TRANSPORTATION.SET_FORM_TRANSPORTANTION:
         return { ...state, formTransportation: [...payload] }

      case CONSTANTS.ACTION.TYPE_FUEL_TRANSPORTATION.GET_TYPE_FUEL_TRANSPORTATION:
         return { ...state, typeFuelTransportation: [] }

      case CONSTANTS.ACTION.TYPE_FUEL_TRANSPORTATION.SET_TYPE_FUEL_TRANSPORTANTION:
         return { ...state, typeFuelTransportation: [...payload] }

      case CONSTANTS.ACTION.REGISTRATION_CENTER_PROVIDER.SET_REGISTRATION_CENTER_PROVIDER:
         return { ...state, registrationCenterProvider: [...payload] }

      case CONSTANTS.ACTION.INSURANCE_CENTER_PROVIDER.SET_INSURANCE_CENTER_PROVIDER:
         return { ...state, insuranceCenterProvider: [...payload] }

      case CONSTANTS.ACTION.CAR_BADGES_CENTER_PROVIDER.SET_CAR_BADGES_CENTER_PROVIDER:
         return { ...state, carBadgesCenterProvider: [...payload] }

      case CONSTANTS.ACTION.CAR_BADGES_TYPE.SET_CAR_BADGES_TYPE:
         return { ...state, carBadgesType: [...payload] }

      case CONSTANTS.ACTION.REGISTRATION_CARD_CENTER_PROVIDER.SET_REGISTRATION_CARD_CENTER_PROVIDER:
         return { ...state, registrationCardCenterProvider: [...payload] }

      case CONSTANTS.ACTION.FACTORY_TRANSPORTATION.SET_FACTORY_TRANSPORTATION:
         return { ...state, factoryTransportation: [...payload] }

      case CONSTANTS.ACTION.MEMBER.SET_MEMBER:
         return { ...state, memberRegister: [...payload] }

      default:
         return { ...state }
   }
}
